import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faGithub, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";

class AboutMe extends React.Component {
  render() {
    return (
      <>
        <div className="page about-me">
          <div className="personal-information">
            <div className="left">
              <img src="/images/ivan-buccella.jpg" />
              <div className="icons-container">
                <a
                  className="link"
                  href="https://it.linkedin.com/in/ivanbuccella"
                  target="_blank"
                >
                  <FontAwesomeIcon icon={faLinkedinIn} size="2x" />
                </a>
                <a
                  className="link"
                  href="https://github.com/IvanBuccella/"
                  target="_blank"
                >
                  <FontAwesomeIcon icon={faGithub} size="2x" />
                </a>
                <a
                  className="link"
                  href="mailto:ivan@buccella.me?subject=Mail from Website"
                >
                  <FontAwesomeIcon icon={faEnvelope} size="2x" />
                </a>
              </div>
            </div>
            <div className="right">
              <p className="role">Senior Software Engineer</p>
              <h1 className="name">Ivan Buccella</h1>
              <h2 className="description">
                Hi! I am a Senior Software Engineer that develops websites, mobile and cloud applications with a special focus on clean architecture, maintainable code, and user-oriented product.<br />
                My areas of expertise include Flutter & Dart (mobile applications), Laravel, Symfony, and Django (backend and full-stack development). Additionally, I have experience with Vue.js, CI/CD, testing and cloud technologies that allow me to produce reliable software.<br />
                During my career, I have had an opportunity to work together with CTOs, stakeholders and agile teams on creating systems, refining processes and implementing concepts as high-quality digital products. The projects I worked on included websites, mobile applications, APIs, DevOps and technical architecture in various industries.<br />
                Recent projects I was involved in included GigAdvisor – a research project dedicated to gig workers, Notes Sound Generator – an accessibility-oriented music playback tool and experiments with AI agents, IoT and cloud technologies.<br />
                I like to learn new things, enjoy creating products that are both technically sound and actually useful. If you appreciate craftsmanship and collaboration – feel free to reach out to me.
              </h2>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default AboutMe;
